import assignAirport from './assignAirport';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import setReservationEntityData from './setReservationEntityData';
import FlightReservation from '../../schema/FlightReservation';
import Entity from '../../schema/Entity';
import tryCreateTxpOwaDate from './tryCreateTxpOwaDate';
import tryCreateTxpUtcDate from './tryCreateTxpUtcDate';

/**
 * parse data for FlightReservation Entity
 */
export default function setFlightEntityData(entity: Entity, flightEntity: any): FlightReservation {
    if (entity && flightEntity) {
        let newFlightEntity: FlightReservation = setReservationEntityData(
            entity,
            flightEntity,
            false /* isReservationIdRequired */
        );
        // assign the flight data
        if (isFlightValid(flightEntity, entity)) {
            let reservationFor = flightEntity.reservationFor;
            let airline = reservationFor.provider;
            newFlightEntity = {
                ...newFlightEntity,
                ...{
                    entityName: EntityTypeNames.FlightReservation,
                    entityType: EntityType.FlightReservation,
                    checkinUrl: flightEntity.checkinUrl
                        ? flightEntity.checkinUrl
                        : flightEntity.potentialAction
                        ? flightEntity.potentialAction.target
                        : null,
                    departureTime: reservationFor.departureTime,
                    departureTimeUTC: reservationFor['departureTime/utc'],
                    departureTerminal: reservationFor.departureTerminal,
                    departureGate: reservationFor.departureGate,
                    departureTimeZone: reservationFor['departureTime/windowsTimeZoneName'],
                    arrivalTime: reservationFor.arrivalTime,
                    arrivalTimeUTC: reservationFor['arrivalTime/utc'],
                    arrivalTerminal: reservationFor.arrivalTerminal,
                    arrivalGate: reservationFor.arrivalGate,
                    arrivalTimeZone: reservationFor['arrivalTime/windowsTimeZoneName'],
                    flightNumber: reservationFor.flightNumber,
                    airline: {
                        name: airline.name,
                        iataCode: airline.iataCode,
                    },
                },
            };
            // assign data for departure airport
            newFlightEntity = <FlightReservation>{
                ...newFlightEntity,
                ...{
                    departureAirport: assignAirport(
                        newFlightEntity,
                        reservationFor.departureAirport
                    ),
                },
            };

            // assign data for arrival airport
            newFlightEntity = <FlightReservation>{
                ...newFlightEntity,
                ...{
                    arrivalAirport: assignAirport(newFlightEntity, reservationFor.arrivalAirport),
                },
            };

            return newFlightEntity as FlightReservation;
        }
    }
    return null;
}

export function isFlightValid(flightEntity: any, entity: Entity): boolean {
    if (flightEntity && flightEntity.reservationFor && flightEntity.reservationFor.provider) {
        let reservationFor = flightEntity.reservationFor;
        let provider = flightEntity.reservationFor.provider;
        // validate Airline
        if (
            provider.iataCode &&
            provider.name &&
            // validate Airports
            isAirportValid(reservationFor.arrivalAirport) &&
            isAirportValid(reservationFor.departureAirport) &&
            // validate require flight details
            reservationFor.flightNumber &&
            reservationFor.arrivalTime &&
            tryCreateTxpOwaDate(reservationFor.arrivalTime, entity) &&
            tryCreateTxpUtcDate(reservationFor.arrivalTimeUTC, entity) &&
            reservationFor.departureTime &&
            tryCreateTxpOwaDate(reservationFor.departureTime, entity) &&
            tryCreateTxpUtcDate(reservationFor.departureTimeUTC, entity)
        ) {
            return true;
        }
    }
    return false;
}

export function isAirportValid(airportBlob: any): boolean {
    if (
        airportBlob &&
        airportBlob.iataCode &&
        (airportBlob['address/commonCity'] ||
            (airportBlob.address && airportBlob.address.addressLocality))
    ) {
        return true;
    }
    return false;
}
